/**
 * API utility functions for fetching Nord Pool prices
 * from Cloudflare Worker or local database
 */

const API_BASE_URL = import.meta.env.DEV 
  ? 'http://localhost:8787/api'  // Local worker
  : 'https://manoelektra-worker.tsivickas.workers.dev/api' // Production (Worker URL)

// Bendros antraštės saugumui
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'X-App-Id': 'mano-elektra-v1' // Identifikatorius, kurį tikrina Worker'is
}

/**
 * Fetch Nord Pool prices for a specific date range
 */
export async function fetchPrices(dateFrom, dateTo) {
  try {
    const params = new URLSearchParams({
      from: dateFrom,
      to: dateTo
    })

    const response = await fetch(`${API_BASE_URL}/prices/range?${params}`, {
      headers: DEFAULT_HEADERS
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching prices:', error)
    throw error
  }
}

/**
 * Fetch prices for a specific date
 */
export async function fetchPricesForDate(date) {
  try {
    const response = await fetch(`${API_BASE_URL}/prices?date=${date}`, {
      headers: DEFAULT_HEADERS
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching prices for date:', error)
    throw error
  }
}

/**
 * Fetch latest prices (today)
 */
export async function fetchLatestPrices() {
  const today = new Date().toISOString().split('T')[0]
  return fetchPricesForDate(today)
}

/**
 * Format price data for charts
 */
export function formatPricesForChart(prices) {
  return prices.map(p => ({
    x: new Date(p.datetime),
    y: p.price
  }))
}
